import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../../base-api.service';
import {PaymentsModelService} from '../../../Models/Finances/Payments/payments-model.service';
import {PaymentsTypesModelService} from '../../../Models/Finances/Cash-closing/payments-types-model.service';
import {forkJoin} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PaymentsApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: PaymentsModelService,
    public modelTypes: PaymentsTypesModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener pagos
   *
   */
  public getPayments(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      const depositsApi = this.httpCall('getAdelantos', {});
      const extrasApi = this.httpCall('getExtras', {});

      return forkJoin([depositsApi, extrasApi]).subscribe({
        next: ([responseDeposits, responseExtras]) => {

          responseExtras.data = responseExtras.data.map((item: any) => ({ ...item, extra: true }));

          const combinedResponse = {
            duracion: responseDeposits.duracion,
            mensaje: `${responseDeposits.mensaje} y ${responseExtras.mensaje}`,
            status: responseDeposits.status === responseExtras.status ? responseDeposits.status : 0,
            data: [...responseDeposits.data, ...responseExtras.data]
          };

          if (save) {
            this.model.save(combinedResponse.data);
          }

          resolve(combinedResponse);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Obtener adelantos
   *
   */
  public getDepositsList(): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getAdelantos', {}).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Obtener extras
   *
   */
  public getExtrasList(): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getExtras', {}).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Obtener las formas de pago
   *
   */
  public getPaymentsTypes(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getFormasPago', {}, 'get').subscribe({
        next: (response) => {

          if (save) {
            this.modelTypes.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }

}
